import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SubCategoryForm from '../../../../components/masters/styles/subCategory/SubCategoryForm';
import SubCategoryTable from '../../../../components/masters/styles/subCategory/SubCategoryTable';
import { addSubCategoryAction, updateSubCategoryAction, clearSubCategoryEdit } from '../../../../redux/actions/masters/styles/subCategory/subCategoryAction';
import { fetchCategories } from '../../../../api/masters/styles/category/categoryApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .sub-category-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .sub-category-form, .sub-category-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const SubCategoryPage = () => {
  const dispatch = useDispatch();
  const { editingSubCategory } = useSelector((state) => state.subCategory);
  const users = useSelector(state => state.users.list || []);
  const [categories, setCategories] = useState([]);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    fetchCategories().then(setCategories);
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingSubCategory && editingSubCategory.sub_category_id) {
        await dispatch(updateSubCategoryAction({ id: editingSubCategory.sub_category_id, subCategory: form }));
        setFormError('');
      } else {
        await dispatch(addSubCategoryAction(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearSubCategoryEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="sub-category-flex">
        <div style={tableContainer} className="sub-category-table">
          <SubCategoryTable onNew={handleFormReset} categories={categories} />
        </div>
        <div style={formContainer} className="sub-category-form">
          <SubCategoryForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingSubCategory={editingSubCategory}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            categories={categories}
            users={users}
          />
        </div>
      </div>
    </div>
  );
};

export default SubCategoryPage; 